import React, { useContext } from 'react'
import { AlertCircle, CheckCircle, Info } from 'react-feather'
import styled, { ThemeContext } from 'styled-components'
import { TYPE } from '../../theme'
import { AutoColumn } from '../Column'
import { AutoRow } from '../Row'

const RowNoFlex = styled(AutoRow)`
  flex-wrap: nowrap;
`

export default function MessagePopup({
  type,
  text
}: {
  type: 'success' | 'error' | 'info'
  text: string
}) {
  const theme = useContext(ThemeContext)

  const Icon = type === 'success' ? CheckCircle : type === 'error' ? AlertCircle : Info
  const iconColor = type === 'success' ? theme.green1 : type === 'error' ? theme.red1 : theme.blue1

  return (
    <RowNoFlex>
      <div style={{ paddingRight: 16 }}>
        <Icon color={iconColor} size={24} />
      </div>
      <AutoColumn gap="8px">
        <TYPE.body fontWeight={500}>{text}</TYPE.body>
      </AutoColumn>
    </RowNoFlex>
  )
}

